module.exports = __webpack_public_path__ + "assets/CleverSaleVertical.8a733998.svg";